import { h, Component, FunctionalComponent } from 'preact'
import cn from 'classnames'
import s from './Checkbox.css'

interface iProps {
  className?: string
  onChange: (e: Event) => void
  checked: boolean
}

export const Checkbox: FunctionalComponent<iProps> = (props) => {
  const {
    children,
    className,
    ...restProps
  } = props

  return (
    <label className={cn(s.Checkbox, className)}>
      <input
        className={s.Checkbox__input}
        type="checkbox"
        {...restProps}
      />

      <span className={s.Checkbox__indicator}/>

      {children && (
        <span className={s.Checkbox__label}>
          {children}
        </span>
      )}
    </label>
  )
}
